module.exports = __webpack_public_path__ + "static/media/Listado-de-productos.d7539aed.xlsx";